export function exhaustiveCheck(param) {
    throw new Error("This should never happen! " + param);
    // const _check: never = param;
    // return _check
}
